'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { OTPInput } from 'input-otp';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const InputOTP = forwardRef(({ className, containerClassName, pattern, ...props }, ref) => (_jsx(OTPInput, { pattern: pattern, ref: ref, containerClassName: cn('flex items-center gap-2.5 has-[:disabled]:opacity-50', containerClassName), className: cn('disabled:cursor-not-allowed', className), ...props })));
InputOTP.displayName = 'InputOTP';
export { InputOTP };
